// Wait for turbolinks load event
$(document).on('turbolinks:load', () => {
})
